import type { NetworkStoreRanking, NetworkStoreRankingSelectionParams } from '@gozoki/api-types'

import { gozokiApiWithAuth } from '../gozokiApi'

export const fetchNetworkStoreRanking = async (
  selection: NetworkStoreRankingSelectionParams,
): Promise<NetworkStoreRanking> => {
  const params: Record<string, string> = {}
  if (selection.storeIds?.length) params.storeIds = selection.storeIds.join(',')
  if (selection.storeAgeFilter) params.storeAgeFilter = selection.storeAgeFilter
  if (selection.ageStoreIds !== undefined)
    params.ageStoreIds = selection.ageStoreIds.length ? selection.ageStoreIds.join(',') : ''
  if (selection.startDate) params.startDate = selection.startDate
  if (selection.endDate) params.endDate = selection.endDate
  if (selection.comparableStartDate) params.comparableStartDate = selection.comparableStartDate
  if (selection.comparableEndDate) params.comparableEndDate = selection.comparableEndDate
  if (selection.cohortUnit) params.cohortUnit = selection.cohortUnit
  if (selection.cohortValue !== undefined) params.cohortValue = String(selection.cohortValue)
  if (selection.comparableCohortUnit) params.comparableCohortUnit = selection.comparableCohortUnit
  if (selection.comparableCohortValue !== undefined)
    params.comparableCohortValue = String(selection.comparableCohortValue)

  const response = await gozokiApiWithAuth.get<NetworkStoreRanking>(
    '/stores/get-network-store-ranking',
    { params: Object.keys(params).length ? params : undefined },
  )
  return response.data
}
